import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable, map } from 'rxjs'
import { ApiResponse } from 'src/app/shared/interfaces/api-response/api-response.interface'
import { WolseleyBranch } from 'src/app/shared/interfaces/wolseley/wolseley-branch.interface'
import { environment } from 'src/environments/environment'

@Injectable({
    providedIn: 'root',
})
export class WolseleyBranchService {
    private httpClient = inject(HttpClient)

    updateWukNumber(wukNumber: string): Observable<any> {
        return this.httpClient.post<any>(`${environment.baseUrl}wolseley-branches/update-wuk`, { wukNumber })
    }

    getBranches(favouritesOnly: boolean = false): Observable<WolseleyBranch[]> {
        return this.httpClient
            .get<
                ApiResponse<WolseleyBranch[]>
            >(`${environment.baseUrl}wolseley-branches?favouritesOnly=${favouritesOnly}`)
            .pipe(map((x) => x.result))
    }

    toggleFavourite(branchId: number): Observable<void> {
        return this.httpClient.post<void>(`${environment.baseUrl}wolseley-branches/${branchId}/favourite`, {})
    }
}
